import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function GovernmentIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.86031 9.93984V18.0998M10.4503 9.93984V18.0998M15.5503 9.93984V18.0998M20.1403 9.93984V18.0998M3.82031 19.7318L3.82031 20.5478C3.82031 21.1191 3.82031 21.4047 3.93149 21.6229C4.02928 21.8148 4.18532 21.9709 4.37724 22.0687C4.59543 22.1798 4.88106 22.1798 5.45231 22.1798H20.5483C21.1196 22.1798 21.4052 22.1798 21.6234 22.0687C21.8153 21.9709 21.9713 21.8148 22.0691 21.6229C22.1803 21.4047 22.1803 21.1191 22.1803 20.5478V19.7318C22.1803 19.1606 22.1803 18.875 22.0691 18.6568C21.9713 18.4648 21.8153 18.3088 21.6234 18.211C21.4052 18.0998 21.1196 18.0998 20.5483 18.0998H5.45231C4.88106 18.0998 4.59543 18.0998 4.37724 18.211C4.18532 18.3088 4.02928 18.4648 3.93149 18.6568C3.82031 18.875 3.82031 19.1606 3.82031 19.7318ZM12.6463 3.89852L5.09828 5.57585C4.64228 5.67719 4.41428 5.72785 4.24409 5.85046C4.09397 5.95861 3.97609 6.10556 3.90308 6.27556C3.82031 6.4683 3.82031 6.70186 3.82031 7.16899L3.82031 8.30784C3.82031 8.8791 3.82031 9.16472 3.93149 9.38291C4.02928 9.57484 4.18532 9.73088 4.37724 9.82867C4.59543 9.93984 4.88106 9.93984 5.45231 9.93984H20.5483C21.1196 9.93984 21.4052 9.93984 21.6234 9.82867C21.8153 9.73088 21.9713 9.57484 22.0691 9.38291C22.1803 9.16472 22.1803 8.8791 22.1803 8.30784V7.16899C22.1803 6.70186 22.1803 6.4683 22.0975 6.27556C22.0245 6.10556 21.9067 5.95861 21.7565 5.85046C21.5863 5.72785 21.3583 5.67719 20.9023 5.57585L13.3543 3.89852C13.2222 3.86916 13.1562 3.85448 13.0894 3.84863C13.0301 3.84343 12.9705 3.84343 12.9112 3.84863C12.8445 3.85448 12.7784 3.86916 12.6463 3.89852Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
